export default __webpack_public_path__ + "static/media/NoOpen.27268732.jpg";